import { buildMessage, ValidateBy } from '../common/ValidateBy';
import { getText } from '../../multi-lang';
export var IS_INSTANCE = 'isInstance';
/**
 * Checks if the value is an instance of the specified object.
 */
export function isInstance(object, targetTypeConstructor) {
    return (targetTypeConstructor && typeof targetTypeConstructor === 'function' && object instanceof targetTypeConstructor);
}
/**
 * Checks if the value is an instance of the specified object.
 */
export function IsInstance(targetType, validationOptions) {
    return ValidateBy({
        name: IS_INSTANCE,
        constraints: [targetType],
        validator: {
            validate: function (value, args) { return isInstance(value, args === null || args === void 0 ? void 0 : args.constraints[0]); },
            defaultMessage: buildMessage(function (eachPrefix, args) {
                if (args === null || args === void 0 ? void 0 : args.constraints[0]) {
                    return (eachPrefix +
                        getText("$property must be an instance of $constraint").replace('$constraint', args.constraints[0].name));
                }
                else {
                    return (eachPrefix +
                        getText("$IS_INSTANCE decorator expects and object as value, but got falsy value.").replace('$IS_INSTANCE', IS_INSTANCE));
                }
            }, validationOptions),
        },
    }, validationOptions);
}
//# sourceMappingURL=IsInstance.js.map